import { useEffect, useId, useRef } from "react";
import PropTypes from "prop-types";
import "./ResultScreen.css";

const SuccessIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" aria-hidden="true" focusable="false">
    <circle cx="24" cy="24" r="22" fill="none" stroke="currentColor" strokeWidth="2" />
    <path
      d="M14 24.5 21 31.5 34 17"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ErrorIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" aria-hidden="true" focusable="false">
    <circle cx="24" cy="24" r="22" fill="none" stroke="currentColor" strokeWidth="2" />
    <path
      d="M24 16v14M24 34v2"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
  </svg>
);

const ResultScreen = ({
  type,
  message,
  title,
  continueLabel = "Continue",
  onContinue,
}) => {
  const isSuccess = type === "success";
  const titleId = useId();
  const messageId = useId();
  const continueRef = useRef(null);

  const resolvedTitle =
    title || (isSuccess ? "Success" : "Something went wrong");

  useEffect(() => {
    continueRef.current?.focus();
  }, []);

  return (
    <div className="result-screen-container">
      <div
        className={`result-screen-dialog ${isSuccess ? "is-success" : "is-error"}`}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby={titleId}
        aria-describedby={message ? messageId : undefined}
      >
        <div
          className={`result-screen-icon ${isSuccess ? "is-success" : "is-error"}`}
        >
          {isSuccess ? <SuccessIcon /> : <ErrorIcon />}
        </div>

        <h2 className="result-screen-title" id={titleId}>
          {resolvedTitle}
        </h2>

        {message ? (
          <p className="result-screen-message" id={messageId}>
            {message}
          </p>
        ) : null}

        <button
          ref={continueRef}
          type="button"
          className="result-screen-button"
          onClick={onContinue}
        >
          {continueLabel}
        </button>
      </div>
    </div>
  );
};

ResultScreen.propTypes = {
  type: PropTypes.oneOf(["success", "error"]).isRequired,
  message: PropTypes.string,
  title: PropTypes.string,
  continueLabel: PropTypes.string,
  onContinue: PropTypes.func.isRequired,
};

export default ResultScreen;
